module.exports = __webpack_public_path__ + "img/qgnz_32_50.prt.78b7271e.jpg";